/**
 * Opt-in language for the two split checkboxes.
 *
 * Strings may contain `{terms_of_use_link}` and `{privacy_link}` tags plus the
 * inline HTML that `replaceDynamicTags` allows; run each through
 * `withPolicyLinks` then `replaceDynamicTags` before rendering.
 */
export const buildSplitConsentCopy = (orgName: string) => ({
  callsAndEmail:
    `Yes, I agree to be contacted by ${orgName} via call and email for real ` +
    "estate services, including robocalls, automated calls, and AI-powered " +
    "communications by call and email. You understand that consent is not " +
    "required to purchase and that you can opt out at any time. You can click " +
    "the unsubscribe link in the emails. Data will not be sold or shared with " +
    "third parties for promotional or marketing purposes. " +
    "{terms_of_use_link} and {privacy_link}.",
  text:
    "Yes, I agree to receive promotional/marketing real estate service " +
    `SMS communications from ${orgName}, including AI-powered SMS ` +
    "communications. Message and data rates may apply. Message frequency may " +
    "vary. To opt out, you can reply ‘STOP’ at any time.",
});
